module.exports = __webpack_public_path__ + "img/chat-dm-selector.47677e03.svg";